<template>
  <div id="engine-deck-builder">
    <div class="orbitist-modal">
      <div class="orbitist-modal-container">
        <div class="orbitist-modal-header">
          <a @click="closeDeckBuilder()" title="Close" class="close clickable"><i class="far fa-times"></i></a>
          <p class="lead">Deck Builder</p>
        </div><!-- /.orbitist-modal-header -->

        <div class="orbitist-modal-content">
          <div class="orbitist-modal-options">

            <p class="mt-3 ml-2"><strong>Details</strong></p>

            <form class="ml-2 mr-2" @submit.prevent>
              <!-- NAME -->
              <div class="form-group">
                <label>Name</label>
                <input v-model="deck.name" class="form-control" placeholder="Deck Name" />
              </div><!-- /.form-group -->
            </form>

          </div><!-- /.orbitist-modal-options -->
          <div class="orbitist-modal-preview pl-2 pr-2">
            <p><strong>Cards</strong></p>
            <!-- ADD CARD FORM -->
            <form @submit.prevent>
              <div class="form-group">
                <label>Add Card to Deck</label>
                <multiselect v-model="cardToAdd" :options="cards" label="name">
                  <template slot="singleLabel" slot-scope="props"><span class="option__desc"><span class="option__title">{{ props.option.name }}</span></span></template>
                  <template slot="option" slot-scope="props">
                    <div class="option__desc"><span class="option__title">{{ props.option.name }} </span><span class="option__small">of {{ props.option.suit.name }}</span></div>
                  </template>
                </multiselect>
                <button @click="addCard()" class="btn btn-outline-secondary mt-2">Add Card</button>
              </div><!-- /.form-group -->
            </form>

            <!-- LIST OF CARDS IN DECK -->
            <b-table striped hover dark small :items="deck.cards" :fields="[{key:'name', sortable:true}, {key:'suit', sortable:true}, 'remove']" class="mt-4">
              <template slot="remove" slot-scope="data">
                <button @click="removeCard(data.item.id)" class="btn btn-sm btn-outline-secondary"><i class="fal fa-trash"></i></button>
              </template>
            </b-table>

          </div><!-- /.orbitist-modal-preview -->

        </div><!-- /.orbitist-modal-content -->

        <div class="orbitist-modal-footer">
          <button v-if="editMode == false" @click="createDeck()" class="btn btn-outline-secondary float-right">Create Deck</button>
          <button v-if="editMode == true" @click="deleteDeck()" class="btn btn-outline-danger float-right ml-2">Delete Deck</button>
          <button v-if="editMode == true" @click="saveDeck()" class="btn btn-outline-secondary float-right">Save Deck</button>
        </div><!-- /.orbitist-modal-footer -->
      </div><!-- /.orbitist-modal-content -->
    </div><!-- /.orbitist-modal -->
  </div><!-- /#engine-card-builder -->
</template>

<script>
const fb = require('../../firebaseConfig.js')
import Multiselect from 'vue-multiselect'

export default {
  data() {
    return {
      cardToAdd: {},
      deck: {
        cards: []
      },
      cardsDisplayed: [],
      editMode: false,
      cards: []
    }
  },
  props: [ 'deckId' ],
  components: { Multiselect },
  created() {
    if (this.deckId) {
      console.log('In edit mode!')
      this.editMode = true
      fb.decksCollection.doc(this.deckId).onSnapshot(deck => {
        this.deck = deck.data()
      })
    }
    this.getCards()
  },
  methods: {
    removeCard(id) {
      for (let i = 0; i < this.deck.cards.length; i++) {
        if (this.deck.cards[i].id == id) {
          this.deck.cards.splice(i,1)
        }
      }
    },
    addCard() {
      this.deck.cards.push({name: this.cardToAdd.name, suit: this.cardToAdd.suit.name, id: this.cardToAdd.id})
    },
    getCards() {
      fb.cardsCollection.orderBy("updatedOn", "desc").onSnapshot(cards => {
        this.cards = []
        for (let i = 0; i < cards.docs.length; i++) {
          let cardItem = cards.docs[i].data()
          cardItem.id = cards.docs[i].id
          this.cards.push(cardItem)
        }
      })
    },
    deleteDeck() {
      let check = confirm("DANGER! Are you sure you want to delete this deck? This cannot be undone!")
      if (check == true) {
        let self = this
        fb.decksCollection.doc(this.deckId).delete().then(function() {
          alert('Deck deleted!')
          self.closeDeckBuilder()
        })
      } else { return false }
    },
    createDeck() {
      this.deck.createdOn = new Date()
      this.deck.updatedOn = new Date()
      let self = this
      fb.decksCollection.add(this.deck).then(function() {
        alert('Deck Created!')
        self.closeDeckBuilder()
      })
    },
    saveDeck() {
      this.deck.updatedOn = new Date()
      let self = this
      fb.decksCollection.doc(this.deckId).update(this.deck).then(function() {
        alert('Deck Saved!')
        self.closeDeckBuilder()
      })
    },
    closeDeckBuilder() {
      this.$emit('closeDeckBuilder')
    }
  }
}
</script>

<style src="vue-multiselect/dist/vue-multiselect.min.css"></style>



// WEBPACK FOOTER //
// src/components/engine/EngineDeckBuilder.vue